
import { useToast } from '@shared/lib/toast'
import { trackEvent } from '@shared/lib/amplitude'

import { useSubscriptionRetryApi } from '../api/subscription-retry.hook'
import { useSubscriptionStore } from './subscription-store/store'

interface FailedPaymentRetryReturn {
  name: string
  btnText: string
  setSubmit: () => Promise<void>
}
export const useFailedPaymentRetry = (): FailedPaymentRetryReturn => {
  const subscriptionStore = useSubscriptionStore()
  const toast = useToast()

  const name = 'retry_payment'
  const btnText = 'Retry payment'

  const setSubmit = async (): Promise<void> => {
    const subscriptionId = subscriptionStore.paymentRetryData?.subscription?.id || null

    trackEvent('Form_submit', {
      feature: 'subscription',
      name,
      is_valid: !!subscriptionId,
      text: btnText,
      subscription_id: subscriptionId,
    })

    if (!subscriptionId) {
      toast.error({
        title: 'Invalid subscription ID',
        description: 'Invalid subscription ID',
      })
    } else {
      const retry = false
      subscriptionStore.setBannerPaymentRetry(retry)
      subscriptionStore.setRetryPaymentModal(retry)

      const processing = true
      subscriptionStore.setBannerPaymentRetryProcessing(processing)
      subscriptionStore.setModalRetryPaymentProcessing(processing)

      await useSubscriptionRetryApi({
        onError: (err: any) => {
          subscriptionStore.setRetryPaymentModal(true)

          const processing = false
          subscriptionStore.setBannerPaymentRetryProcessing(processing)
          subscriptionStore.setModalRetryPaymentProcessing(processing)

          toast.error({
            title: 'Unexpected error',
            description: err.response?.data?.message || err?.message || 'Unexpected error',
          })
        },
      })
    }
  }

  return {
    name,
    btnText,
    setSubmit,
  }
}
